import React from 'react'
import {
  Container,
  FormLabel,
  FormDashboardInput as FormInput,
  FormDashboardTextarea,
  Button,
  FormRow
} from '../../../components'
import { MobileViewportProvider } from '../../../utils'

const MainContent = () => {
  return (
    <Container>
      <div className="pt-8 lg:pt-20 pb-16 lg:pb-24 flex flex-wrap -mx-4">
        <div className="w-full md:w-8/12 lg:w-6/12 px-4 lg:ml-auto">
          <h2 className="font-bold font-primary text-lg mb-4">Send Us a Message</h2>
          <form className="lg:mr-24">
            <FormRow>
              <FormLabel>Name</FormLabel>
              <FormInput className="w-full" />
            </FormRow>

            <FormRow>
              <FormLabel>Company/Institution</FormLabel>
              <FormInput className="w-full" />
            </FormRow>

            <div className="flex flex-wrap -mx-4">
              <div className="w-full md:w-6/12 px-4">
                <FormRow>
                  <FormLabel>Email</FormLabel>
                  <FormInput className="w-full" placeholder="Email" />
                </FormRow>
              </div>
              <div className="w-full md:w-6/12 px-4">
                <FormRow>
                  <FormLabel>Phone</FormLabel>
                  <FormInput className="w-full" placeholder="Phone Number" />
                </FormRow>
              </div>
            </div>

            <FormRow>
              <FormLabel>Messages</FormLabel>
              <FormDashboardTextarea className="w-full" rows={5} placeholder="Your Messages" />
            </FormRow>

            <div className="flex flex-wrap -mx-4">
              <div className="w-full md:w-6/12 px-4">
                <div className="hidden lg:block">
                  <Button>Submit</Button>
                </div>
                <MobileViewportProvider>
                  <Button thin>Submit</Button>
                </MobileViewportProvider>
              </div>
            </div>
          </form>
        </div>

        <div className="w-full md:w-4/12 lg:w-3/12 px-4 lg:mr-auto mt-10 md:mt-0">
          <h2 className="font-bold font-primary text-lg mb-4">Get in Touch</h2>
          <div className="text-sm mb-5 lg:mb-8">
            <h3 className="font-semibold font-primary">Location</h3>
            {/* <p className="text-gray-444">Gedung KHUB <br/>
            Jalan Daan Mogot No.63 Tj. Duren Utara<br/>
            Kec. Grogol petamburan, <br/>
            Daerah Khusus Ibukota Jakarta 11470</p> */}
          </div>

          <div className="text-sm lg:mb-8">
            <h3 className="font-semibold font-primary">Phone &amp; Email</h3>
            {/* <p className="text-gray-444">+6222 7323101<br/>admin@khub.org</p> */}
          </div>

        </div>
      </div>
    </Container>
  )
}

export { MainContent }
